import { apiFetch } from './client';
import { Endpoints, type TokenRequest, type TokenResponse } from './types';

/**
 * Exchanges a (tenantId, apiKey) pair for a short-lived JWT.
 *
 * The endpoint is intentionally opaque on failure — every credential mismatch
 * returns the same 401 body, so callers should not try to disambiguate.
 */
export function postToken(payload: TokenRequest): Promise<TokenResponse> {
  return apiFetch<TokenResponse>(Endpoints.authToken, {
    method: 'POST',
    json: payload,
    skipAuth: true,
  });
}
